module.exports = __webpack_public_path__ + "img/logo-text-light.8f3f466f.svg";